"use client";

import {
  BookOpen,
  FileText,
  Rocket,
  Workflow,
  SlidersHorizontal,
  History,
  CodeXml,
  ListChecks,
  Bug,
  MessagesSquare,
  KeyRound,
  Sparkles,
  Github,
  RefreshCw,
  CheckCheck,
  Terminal,
  Settings,
  Monitor,
} from "lucide-react";
import { NexumNavigation } from "./nexum/navigation";
import PowerOnPipelines from "@/components/icons/poweron-pipelines";
import PowerOnPro from "@/components/icons/poweron-pro";
import { NavSecondary } from "@/components/nav-secondary";
import {
  docsContexts,
  docsHref,
  docsPages,
  docsPipelineLinks,
  docsProLinks,
} from "@/lib/docs/catalog";

const topicIcons: Record<string, typeof BookOpen> = {
  Introduction: BookOpen,
  Commands: Terminal,
  Settings: Settings,
  "Setting up Rsync on Windows": Monitor,
  "PowerOn Pro": PowerOnPro,
  "VS Code Marketplace": PowerOnPro,
  "Libum GitHub": Github,
  Overview: BookOpen,
  Quickstart: Rocket,
  "GitHub Actions": Workflow,
  Configuration: SlidersHorizontal,
  Changelog: History,
  Examples: CodeXml,
  Tasks: ListChecks,
  "Known Issues": Bug,
  "Help & Feedback": MessagesSquare,
  Authentication: KeyRound,
  "API Reference": CodeXml,
  Capabilities: Sparkles,
  "PowerOn Pipelines": PowerOnPipelines,
  "Validate PowerOn": CheckCheck,
  "Synchronize Symitar": RefreshCw,
  GitHub: Github,
};

export function DocsNavigation({ context }: { context: string }) {
  if (context === "nexum") return <NexumNavigation />;
  const product = docsContexts.find((entry) => entry.slug === context)!;
  const groups = product.legacyUrl
    ? [
        {
          title: "General",
          url: `/docs/${context}`,
          pages: [
            {
              title: "Introduction",
              url: `/docs/${context}`,
              exactMatch: true,
              icon: BookOpen,
            },
            {
              title: "API Reference Preview",
              url: "/docs/nexum/reference",
              exactMatch: false,
              icon: CodeXml,
            },
          ],
        },
      ]
    : (context === "glaci"
        ? ["Getting started"]
        : context === "poweron-pro"
          ? ["Getting started", "Links", "How To’s", "Resources"]
          : ["Getting started", "Links", "Resources"]
      ).map((group) => ({
        title: group,
        url: `/docs/${context}`,
        pages:
          group === "Links"
            ? (context === "poweron-pro"
                ? docsProLinks
                : docsPipelineLinks
              ).map((link) => ({
                ...link,
                iconClassName:
                  link.title === "Libum GitHub" ? "!text-inherit" : undefined,
                icon: topicIcons[link.title] ?? FileText,
              }))
            : docsPages
                .filter(
                  (page) => page.group === group && page.product === context,
                )
                .map((page) => ({
                  title: page.title,
                  url: docsHref(page.slug, page.product),
                  exactMatch: true,
                  icon: topicIcons[page.title] ?? FileText,
                })),
      }));
  return (
    <nav aria-label={`${product.title} documentation`}>
      <NavSecondary asLinks items={groups} />
    </nav>
  );
}
